import { CopyOutlined } from '@ant-design/icons';
import { Button, Col, Row, Tooltip, Typography } from 'antd';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import Title from './Title';

interface CandidateManagerFeedbackProps {
  managerFeedbackLink?: string;
}

const CandidateManagerFeedback: React.FC<CandidateManagerFeedbackProps> = ({
  managerFeedbackLink,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Title title={t('Relatório do Gestor')} />
      <Row gutter={[16, 16]}>
        <Col span={19}>
          <Typography.Text>
            <Trans>
              Copie e cole no navegador para visualizar o relatório. Lembrando que o link contém
              informações sensíveis para o candidato, é importante que ele seja compartilhado
            </Trans>{' '}
            <Typography.Text strong>
              <Trans>apenas com o gestor</Trans>.
            </Typography.Text>
          </Typography.Text>
        </Col>
        <Col span={5}>
          <Tooltip
            trigger="click"
            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
            title={
              <>
                <Typography.Text style={{ color: 'white' }}>
                  <Trans>Link do relatório copiado</Trans>!
                </Typography.Text>
                <br />
                <Typography.Text style={{ color: 'white' }}>
                  <Trans>Compartilhe com seu gestor</Trans>
                </Typography.Text>
              </>
            }
          >
            <Button
              icon={<CopyOutlined />}
              type="link"
              style={{ borderColor: 'lightskyblue' }}
              onClick={async () => {
                await navigator.clipboard.writeText(managerFeedbackLink || '');
              }}
            >
              {' '}
              <Trans>Copiar</Trans>
            </Button>
          </Tooltip>
        </Col>
      </Row>
    </>
  );
};

export default CandidateManagerFeedback;
